export const PODIUM_STYLES = {
  1: {
    surface: "rgba(255, 239, 174, 0.18)",
    rankText: "text-[#C58A00]",
  },
  2: {
    surface: "rgba(236, 241, 246, 0.18)",
    rankText: "text-[#98A2B3]",
  },
  3: {
    surface: "rgba(248, 224, 204, 0.18)",
    rankText: "text-[#C97C37]",
  },
} as const;
